import {
  AUTO_FILL_UPGRADE_AMOUNT,
  CURRENT_ACTIVATION_FEE,
  isCurrentTierActivationFee,
  LEGACY_ACTIVATION_FEE,
  PREVIOUS_CURRENT_ACTIVATION_FEE,
} from "../config/membershipConfig";
import { AUTO_FILL_ENTRY_AMOUNTS } from "../config/autoFillProgramConfig";

/**
 * Activation fee encoded on a package / order (membership checkout).
 */
export function resolveOrderActivationFee(order, pkg) {
  if (pkg?.isAutoFillUpgrade || order?.isAutoFillUpgrade) {
    return CURRENT_ACTIVATION_FEE;
  }

  const candidates = [
    pkg?.activationFee,
    pkg?.subItemsData?.activationFee,
    order?.subItemsData?.activationFee,
    order?.activationFee,
    order?.purchasedActivationFee,
  ];

  for (const value of candidates) {
    if (value != null && value !== "") {
      const n = Number(value);
      if (!Number.isNaN(n)) return n;
    }
  }

  const price = Number(pkg?.price);
  if (price === LEGACY_ACTIVATION_FEE) return LEGACY_ACTIVATION_FEE;
  if (price === CURRENT_ACTIVATION_FEE || price === PREVIOUS_CURRENT_ACTIVATION_FEE) {
    return price;
  }

  if (pkg?.isSubItemPackage) {
    return CURRENT_ACTIVATION_FEE;
  }

  return null;
}

/** Auto Fill upgrade (legacy ₹499 → current Ultra + AFP). */
export function isAutoFillUpgradeOrder(order, pkg) {
  return (
    order?.isAutoFillUpgrade === true ||
    pkg?.isAutoFillUpgrade === true ||
    pkg?.category === "Auto Fill Upgrade"
  );
}

/**
 * Creates an AFP when:
 * - ₹150 Auto Fill / upgrade order, or
 * - New ₹699 membership (activation included), not legacy ₹499-only.
 */
export function orderQualifiesForAutoFillProgram(order, pkg) {
  if (isAutoFillUpgradeOrder(order, pkg)) return true;

  const price = Number(pkg?.price);
  if (
    price === AUTO_FILL_UPGRADE_AMOUNT ||
    price === 150 ||
    AUTO_FILL_ENTRY_AMOUNTS.includes(price)
  ) {
    return true;
  }

  const fee = resolveOrderActivationFee(order, pkg);
  if (isCurrentTierActivationFee(fee)) return true;
  if (fee === LEGACY_ACTIVATION_FEE) return false;

  return false;
}

/** Voucher / direct grant at current activation tier includes AFP. */
export function voucherActivationIncludesAutoFill(activationFee) {
  return isCurrentTierActivationFee(activationFee);
}
